// eslint-disable-next-line import/prefer-default-export
export const ADD_IS_WEBVIEW = "ADD_IS_WEBVIEW";
